import { configureStore } from "@reduxjs/toolkit";
import componentSlice from "../Reducer/componentSlice";

const store = configureStore({
    reducer: {
        component: componentSlice,
    },
});

export default store;
